'use client'

import { MultiChoiceSentenceQuestion, PronounceRubyRequest } from '@entities/lesson'
import { useTranslation } from '@shared/config/i18n'
import React, { Suspense } from 'react'
import { match } from 'ts-pattern'

import { ChipV2, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  question: MultiChoiceSentenceQuestion
  value: Undefinable<string>
  handleChangeCurrentFunnelValue: (value: string) => void
}

export const EnglishMultiChoiceSentenceQuizFunnel = ({ question, value, handleChangeCurrentFunnelValue }: Props) => {
  const t = useTranslation()

  return (
    <React.Fragment>
      <VStack className="py-5 gap-2">
        <Typography size="h1" className="font-medium">
          {question.source.body.sentence}
        </Typography>
      </VStack>

      <VStack className="gap-2">
        <Typography className="text-gray-400" size="h6">
          {t('lesson.quiz.answerInput')}
        </Typography>
        {question.source.body.options.map((option, index) => (
          <ChipV2
            key={option}
            selected={index.toString() === value}
            onClick={() => handleChangeCurrentFunnelValue(index.toString())}
            fontWeight="medium"
          >
            {option}
          </ChipV2>
        ))}
      </VStack>
    </React.Fragment>
  )
}

export const JapaneseMultiChoiceSentenceQuizFunnel = ({
  question,
  value,
  handleChangeCurrentFunnelValue,
}: Props & { contentLevel: number }) => {
  const t = useTranslation()

  return (
    <React.Fragment>
      <VStack className="py-5 gap-2">
        <Typography size="h1" className="text-[22px]">
          {match(question.content_level)
            .when(
              (level) => level === 2,
              () => (
                <Suspense fallback={question.source.body.sentence}>
                  <PronounceRubyRequest text={question.source.body.sentence} />
                </Suspense>
              ),
            )

            .otherwise(() => question.source.body.sentence)}
        </Typography>
      </VStack>

      <VStack className="gap-2">
        <Typography className="text-gray-400" size="h6">
          {t('lesson.quiz.answerInput')}
        </Typography>
        {question.source.body.options.map((option, index) => (
          <ChipV2
            key={option}
            selected={index.toString() === value}
            onClick={() => handleChangeCurrentFunnelValue(index.toString())}
            fontWeight="medium"
          >
            {option}
          </ChipV2>
        ))}
      </VStack>
    </React.Fragment>
  )
}
